/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalySetting {
    getFixupPrototypeFunction() { return CostAnomalySetting.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalySetting>): CostAnomalySetting {
        let obj = Object.assign(new CostAnomalySetting(), model);
        CostAnomalySetting.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalySetting>): CostAnomalySetting {
        if (!model) return null;
        return CostAnomalySetting.newInstance(<CostAnomalySetting> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalySetting) {
        if (!obj) return;

        models.CostAnomalySetting.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalySetting): boolean {
        Object.setPrototypeOf(obj, CostAnomalySetting.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.minimum_cost_spend === undefined) {
            this.minimum_cost_spend = 0;
        }
        if (this.minimum_cost_impact === undefined) {
            this.minimum_cost_impact = 0;
        }
        if (this.minimum_cost_impact_percentage === undefined) {
            this.minimum_cost_impact_percentage = 0;
        }
    }

    /**
     * Cost anomaly settings category.
     */
    category: models.CostAnomalySettingCategory;

    /**
     * List of categories.
     */
    category_values: Array<string>;

    /**
     * Minimum Cost Spend
     */
    minimum_cost_spend: number;

    /**
     * Minimum Cost Impact
     */
    minimum_cost_impact: number;

    /**
     * Minimum Cost Anomaly Impact Percentage
     */
    minimum_cost_impact_percentage: number;

    /**
     * Cost Impact and Spend condition
     */
    cost_impact_spend_operator: models.CostImpactSpendOperator;

}
